import React, { useEffect, useState } from "react";


export const BloqueHomeAcciones = () => {
    const [cargaOferta, setCargaOferta] = useState('');

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/cargaoferta')).json();

        setCargaOferta(
            `${endpoint.url_base}${endpoint.url_variable}`
        )
        }
        asyncFunction();
    }, []);

    return (
        <div className="bloqueHomeAcciones bg-gray">
            <h1 className="title30">OTRAS ACCIONES</h1>
            <div className="bloqueHomeAcciones--buttons">
                <a
                    className="btn-heroHome"
                    target="_blank"
                    href={cargaOferta}
                >
                    <button className="mt-half">
                        OFERTA DE LICITACION
                        <img
                            className="ml-half"
                            src="/images/icons/small.svg"
                        />
                    </button>
                </a>
                <a
                    className="btn-heroHome"
                    target="_blank"
                    href="https://crmfcalatam.my.site.com/selfservicepda/s/submit-request-jeep-fin-de-grupo"
                >
                    <button className="mt-half">
                        SOLICITUD DE REINTEGRO
                        <img
                            className="ml-half"
                            src="/images/icons/small.svg"
                        />
                    </button>
                </a>
            </div>
        </div>
    );
};
